<!-- CP連携ページの場合 -->
<app-doctors-next-register-connect-cportal *ngIf="flagment">
</app-doctors-next-register-connect-cportal>

<ng-container *ngIf="!flagment">
  <app-doctors-next-register-additional [clientId]="clientId"
    *ngIf="registerState.inputStep === 'speciality'"></app-doctors-next-register-additional>

  <app-doctors-next-register-confirm [errorMessages]="errorMessages" [clientId]="clientId" (finish)="_register()"
    *ngIf="registerState.inputStep === 'confirm'"></app-doctors-next-register-confirm>


  <div id="wrapper" class="h-100vh p-3" *ngIf="registerState.inputStep === 'base'">
    <div id="content-wrapper" class="d-flex flex-column ml-0" *ngIf="false">
      <!-- Main Content -->
      <div id="content">
        <div class="container-fluid">

          <div class="row" style="letter-spacing: 0">
            <div style="text-align: center; margin-top: 35vh; width: 100%">
              <h1>現在メンテナンス中です。</h1>
              <p style="margin-top: 30px;">
                現在、一時的にサービスを停止しております。
                <br>
                皆様にはご不便をおかけしますが、メンテナンス終了まで今しばらくお待ち下さい。
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Content Wrapper -->
    <div id="content-wrapper" class="d-flex flex-column ml-0">
      <!-- Main Content -->
      <div id="content">
        <div class="container-fluid">
          <div class="row logo">
            <div class="col-12 row no-gutters justify-content-center">
              <h1 class="d-flex justify-content-center" style="flex-direction: column; align-items: center">
                <img src="/assets/doctors-next/Logo.png" alt="Doctors Next" />
              </h1>
            </div>
          </div>

          <div class="row" style="letter-spacing: 0">

            <form (submit)="nextStep()" class="col-12 mx-auto center-block mt-5">
              <input type="hidden" name="_token" value="4gMwbicnRlsLpqtDdCdBYSg6BzWa5iay6srhgwdQ" />

              <input type="hidden" name="qrCode" value="" />
              <div *ngIf="!isRegistable" class="row no-gutters mx-auto error-message">
                <div class="col-md-12 col-12">
                  <div class="alert alert-danger" role="alert">
                    <ul class="m-0">
                      <li *ngIf="errorMessages.signup.givenName">
                        {{ errorMessages.signup.givenName }}
                      </li>
                      <li *ngIf="errorMessages.signup.familyName">
                        {{ errorMessages.signup.familyName }}
                      </li>
                      <li *ngIf="errorMessages.signup.password">
                        {{ errorMessages.signup.password }}
                      </li>
                      <li *ngIf="errorMessages.signup.confirmPassword">
                        {{ errorMessages.signup.confirmPassword }}
                      </li>
                      <li *ngIf="errorMessages.signup.email">
                        {{ errorMessages.signup.email }}
                      </li>
                      <li *ngIf="errorMessages.signup.terms">
                        {{ errorMessages.signup.terms }}
                      </li>
                      <li *ngIf="errorMessages.signup.privacyPolicy">
                        {{ errorMessages.signup.privacyPolicy }}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div class="form-group row no-gutters mx-auto name-form-group">
                <div class="reg_lname">
                  <div class="input-group justify-content-center">
                    <label for="last_name" class="col-form-label mb-0 py-0 label-name"
                      style="font-size: 16px !important">姓</label>
                  </div>
                  <div>
                    <input type="text" class="form-control input-name" id="last_name" name="last_name" [ngClass]="
                      errorMessages.signup.familyName ? ['is-invalid'] : []
                    " placeholder="鈴木" [(ngModel)]="lastName" />
                  </div>
                </div>

                <div class="reg_fname">
                  <div class="input-group justify-content-center">
                    <label class="col-form-label mb-0 py-0 label-name" for="first_name"
                      style="font-size: 16px !important">名</label>
                  </div>
                  <div>
                    <input type="text" class="form-control input-name" id="first_name" name="first_name" [ngClass]="
                      errorMessages.signup.givenName ? ['is-invalid'] : []
                    " placeholder="一郎" [(ngModel)]="firstName" />
                  </div>
                </div>
              </div>

              <div class="form-group row no-gutters mx-auto name-form-group" style="width: 300px;">
                <div class="input-group justify-content-center">
                  <label class="col-form-label mb-0 py-0" for="email" style="font-size: 16px !important">生年月日</label>
                </div>
                <div class="input-group justify-content-center" style="align-items: center;">
                  <select class="form-control" id="year" name="year" [(ngModel)]="birthdate.year">
                    <option [value]="year" *ngFor="let year of birthdateMaster.years">{{year}}</option>
                  </select>
                  <p style="color: black">年</p>
                  <select class="form-control" id="pref" name="pref" [(ngModel)]="birthdate.month">
                    <option [value]="month" *ngFor="let month of birthdateMaster.months">{{month}}</option>
                  </select>
                  <p style="color: black">月</p>
                  <select class="form-control" id="pref" name="pref" [(ngModel)]="birthdate.date">
                    <option [value]="date" *ngFor="let date of birthdateMaster.dates">{{date}}</option>
                  </select>
                  <p style="color: black">日</p>
                </div>
              </div>

              <div class="form-group">
                <div class="input-group justify-content-center">
                  <label class="col-form-label mb-0 py-0" for="email" style="font-size: 16px !important">メールアドレス</label>
                </div>
                <div class="input-group justify-content-center">
                  <input [ngClass]="errorMessages.signup.email ? ['is-invalid'] : []" type="text" class="form-control"
                    id="email" name="email" placeholder="メールアドレス" value="" aria-describedby="email-help"
                    [(ngModel)]="email" />
                </div>
              </div>

              <div class="form-group">
                <div class="input-group justify-content-center">
                  <label for="password" class="col-form-label mb-0 py-0"
                    style="font-size: 16px !important">パスワード</label>
                </div>
                <div class="input-group justify-content-center">
                  <input [ngClass]="
                    errorMessages.signup.password ? ['is-invalid'] : []
                  " type="password" class="form-control" id="password" name="password" placeholder="パスワード"
                    [(ngModel)]="password" />
                </div>
                <div class="input-group justify-content-center">
                  <span class="text-gray-500 password-note">大文字・小文字を含む8文字以上の半角英数字記号で入力してください。</span>
                </div>
              </div>

              <div class="form-group">
                <div class="input-group justify-content-center">
                  <label for="confirm-password" class="col-form-label mb-0 py-0"
                    style="font-size: 16px !important">パスワード（確認用）</label>
                </div>
                <div class="input-group justify-content-center">
                  <input [ngClass]="
                    errorMessages.signup.confirmPassword ? ['is-invalid'] : []
                  " type="password" class="form-control" id="confirm-password" name="confirm-password"
                    placeholder="パスワード" [(ngModel)]="confirmPassword" />
                </div>
              </div>

              <div class="form-group row no-gutters justify-content-center terms-checkbox">
                <div class="custom-control custom-checkbox custom-control-lg">
                  <input type="checkbox" class="custom-control-input" id="terms-of-use" name="terms-of-use"
                    [(ngModel)]="acceptTerm" />
                  <label class="custom-control-label" for="terms-of-use">
                    <a [href]="baseLink + '/terms-doctor'" target="_blank">
                      Doctors Next<sup>®</sup>利用規約 に同意します。
                    </a>
                  </label>
                </div>
              </div>

              <div class="form-group row no-gutters justify-content-center mb-4"
                style="margin-bottom: 2.75rem !important">
                <div class="custom-control custom-checkbox custom-control-lg">
                  <input type="checkbox" class="custom-control-input" id="privacy-policy" name="privacy-policy"
                    [(ngModel)]="acceptPrivacyPolicy" />
                  <label class="custom-control-label" for="privacy-policy">
                    <a [href]="baseLink + '/privacy'" target="_blank">
                      Doctors
                      Next<sup>®</sup>個人情報の取扱いについてに同意します。
                    </a>
                  </label>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12 text-center">
                  <button type="submit" class="btn mb-4">次へ</button>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12 text-center">
                  <a (click)="navigate('login')" style="cursor: pointer">ログイン</a>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>